// Module
var code = `<div>
    <terceraPanel name="windowPanelFooter" />
</div>`;
// Exports
export default code;